import React from "react";
import { H2 } from "@shoptet/ui";
import { useTranslation } from "react-i18next";
import { Accordion } from "../../elements/Accordion";
import CreditsDashboardBox from "../../elements/Credits/CreditsDashboardBox";
import { ReturnCredits } from "../../elements/Credits/ReturnCredits";

const Credit = () => {
  const { t } = useTranslation("translation", { keyPrefix: "Settings Page" });
  return (
    <div>
      <div style={{ marginBottom: "24px" }}>
        <H2>{t("Credits Page Headline")}</H2>
      </div>
      <CreditsDashboardBox hideStatusMessage />
      <div style={{ marginTop: "24px" }}>
        <Accordion header={t("Return Credits Headline")}>
          <ReturnCredits />
        </Accordion>
      </div>
    </div>
  );
};

export default Credit;
